// 品牌元数据配置（网页端）

declare const __APP_VERSION__: string

// ── 版本号 ──
export const APP_VERSION: string = __APP_VERSION__

// ── 品牌名称（locale-aware，从 i18n app.name 取）──
// APP_NAME 常量已删除；通过 useBrand().name 获取

// ── Slogan 3 语（长 slogan，APP_TAGLINE 替代）──
export const APP_SLOGAN: Record<string, string> = {
  'zh-CN': '体育赛事回放剧透信息隐藏助手',
  'zh-TW': '體育賽事回放劇透資訊隱藏助手',
  en: 'Replay Shield for Sports Videos'
}

// ── 描述 ──
export const APP_DESCRIPTION =
  '体育赛事回放剧透信息隐藏助手 — 安安静静 看个回放！，支持 Chrome、Edge、Firefox 三浏览器。'

// ── Logo 路径 ──
export const BRAND_LOGO = '/icons/logo.png'
export const BRAND_FAVICON = '/icons/favicon.png'

// ── 官方信息 ──
export const OFFICIAL_SITE_URL = 'https://woofootball.site'
export const SUPPORT_EMAIL = 'woofootball@aliyun.com'

// ── 商店上架 URL（隐分宝在三大浏览器的真实列表页）──
export const STORE_URLS = {
  chrome: 'https://chromewebstore.google.com/detail/%E9%9A%90%E5%88%86%E5%AE%9D/kagiibpabaiokolfogibbncebfmeolfa',
  edge: 'https://microsoftedge.microsoft.com/addons/detail/cmijmekhhhgaijgaoijjafggfhomkfaj',
  firefox: 'https://addons.mozilla.org/zh-CN/firefox/addon/yfb/'
} as const

// ── 手动 .crx 包走 API `/yfb/download` 签名下载；保留基地址用于 i18n 引用 ──
export const DOWNLOAD_BASE_URL = `${OFFICIAL_SITE_URL}/yfb`

// ── 浏览器官网下载页（去装浏览器时用，移动端由官网自己跳商店）──
export const BROWSER_DOWNLOAD_URLS = {
  chrome: 'https://www.google.com/chrome/',
  edge: 'https://www.microsoft.com/edge',
  firefox: 'https://www.mozilla.org/firefox/'
} as const

// ── 平台代码（与 v5 一致）──
export type BrowserPlatform = 'chrome' | 'edge' | 'firefox'

export const PLATFORM_CODE: Record<BrowserPlatform, number> = {
  chrome: 11,
  firefox: 12,
  edge: 13
}

export const PLATFORM_LABEL: Record<BrowserPlatform, string> = {
  chrome: 'Chrome',
  edge: 'Edge',
  firefox: 'Firefox'
}